<template>
    <div :class="iconWrapperClass">
        <slot/>
    </div>
</template>

<script>
// ur-icon-wrapper 은 ur-icon을 div로 감싸는 컴포넌트입니다.
// #ur-icon-wrapper is a component that wraps the ur-icon in a div.
export default {
    name: 'ur-icon-wrapper',
    props: {
        // $ver: v0.1.0
        // 작은크기 사이즈로 표현합니다.
        // #Expressed in small size.
        // $default: false
        small: {type: Boolean, default: false},
        // $ver: v0.1.0
        // 큰크기 사이즈로 표현합니다.
        // #Expressed in large size.
        // $default: false
        large : {type: Boolean, default: false},
        // $ver: v0.1.0
        // 중간크기 사이즈로 표현합니다.
        // #Expressed in medium size.
        // $default: false
        medium : {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: large
        lg: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: medium
        md: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: small
        sm: {type: Boolean, default: false},
    },
    computed: {
        iconWrapperClass() {
            let rtn =[];
            rtn.push('ur-icon-wrapper');
            if(this.small  || this.sm) {rtn.push('ur-icon-wrapper--small' );}
            if(this.medium || this.md) {rtn.push('ur-icon-wrapper--medium');}
            if(this.large  || this.lg) {rtn.push('ur-icon-wrapper--large' );}
            return rtn;
        }
    }
}
</script>
